var _require = require('crypto'),
    TSE = _require.timingSafeEqual;

var paddedBuffer = function paddedBuffer(input, length) {
  if (input.length === length) {
    return input;
  }

  var buffer = Buffer.alloc(length);
  input.copy(buffer);
  return buffer;
};

var timingSafeEqual = function timingSafeEqual(a, b) {
  var length = Math.max(a.length, b.length);
  return TSE(paddedBuffer(a, length), paddedBuffer(b, length));
};

module.exports = timingSafeEqual;